import { useContext } from "react";
import { Navigate } from "react-router";
import { AppContext } from "../../../contexts/AppContext";
import { LoadingContent } from "../Shared/LoadingContent";

/// Makes sure that the user is authenticated to render its child content, if the user is not authenticated the page redirects to the landiing page
/// See AnonRoute for opposite
export const ProtectedRoute = (props: React.PropsWithChildren<any>) => {
    const app = useContext(AppContext);

    if (!app.loading && !app.userLoggedIn) {
        // user is not authenticated
        return <Navigate to="/" />;
    }

    return (<>
        <LoadingContent loading={app.loading} classes="w-100 text-center">
            {props.children}
        </LoadingContent>
    </>);
}